var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2617 22.716C5.30769 21.8917 1.5238 17.5594 1.5238 12.381C1.5238 6.61907 6.23809 1.90479 12 1.90479C17.7619 1.90479 22.4762 6.61907 22.4762 12.381C22.4762 17.5594 18.686 21.8917 13.732 22.716",
    stroke: "#004853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7314 22.7762V15.6197C13.7314 15.5145 13.8166 15.4293 13.9218 15.4293L15.689 15.4293C15.8683 15.4293 16.0233 15.3043 16.0613 15.1291L16.493 13.1408C16.5712 12.7807 16.2932 12.4419 15.9248 12.4482L13.7935 12.4849C13.6871 12.4867 13.5998 12.4009 13.5998 12.2945V10.5299C13.5998 9.68786 14.2827 9.00546 15.1247 9.00605L16.3807 9.00694C16.5912 9.00709 16.7619 8.83649 16.7619 8.62599V6.49567C16.7619 6.323 16.6464 6.17155 16.4783 6.13239C15.434 5.88917 12.8895 5.45804 11.5 6.50013C10.0227 7.60811 10.245 10.7496 10.2656 12.3011C10.267 12.4063 10.1817 12.4905 10.0766 12.4905H8.05689C7.81517 12.4905 7.61922 12.6864 7.6192 12.9281L7.61905 14.9394C7.61903 15.21 7.83833 15.4293 8.10885 15.4293L10.0764 15.4293C10.1817 15.4293 10.267 15.5146 10.2669 15.6199L10.262 22.7762",
    stroke: "#004853",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.973a3d6fd12a6bad011cc7a8a50757ff.svg";
export { ForwardRef as ReactComponent };